/**
* For this scoped component we should use the namespace prefix of "dc-text"
*/
:host {
  display: block;
  outline: none;
}

:host * {
  font-family: var(--dc-font-family);
  font-size: 16px;
  font-weight: 400;
}

.dc-text-root {
  display: block;
  height: 72px;
  max-width: 400px;
  min-width: 272px;
  position: relative;
}

.dc-text-input-wrap {
  display: block;
}

.dc-text-label {
  background-color: var(--dc-background-colour);
  color: var(--dc-primary-text-color);
  left: 12px;
  line-height: 22px;
  margin: 0;
  outline: none;
  padding: 0 4px;
  position: absolute;
  top: 15px;
  transition: all 0.3s;
}

.dc-text-input {
  background-color: var(--dc-background-colour);
  border: 1px solid var( --dc-ui-border-default);
  border-radius: 8px;
  box-sizing: border-box;
  caret-color: var(--dc-primary-colour);
  color: var(--dc-primary-text-color);
  display: block;
  font-size: 16px;
  font-weight: 400;
  height: 52px;
  line-height: 24px;
  outline: none;
  padding: 14px 16px;
  text-overflow: ellipsis;
  width: 100%;
}

.dc-text-input:hover {
  border-color: var(--dc-primary-accent-colour);
}

.dc-text-input::placeholder {
  color: transparent;
}

.dc-text-help {
  color: var(--dc-greyscale-03);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-left: 16px;
  padding-top: 4px;
  outline: none;
}

/* Feedback icons for working and done */
.dc-text-indicator {
  display: inline-block;
  height: 24px;
  left: calc(100% - 36px);
  position: absolute;
  top: 15px;
}

.dc-text-tick path {
  fill: var(--dc-primary-colour);
}

.dc-text-spinner {
  animation: dc-text-spinner-rotate 2s linear infinite;
}

.dc-text-spinner circle {
  animation: dc-text-spinner-dash 1.5s ease-in-out infinite;
  fill: none;
  stroke: var(--dc-primary-colour);
  stroke-linecap: round;
}

@keyframes dc-text-spinner-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dc-text-spinner-dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

/* Edit mode */
.dc-text-edit .dc-text-label {
  font-size: 12px;
  line-height: 16px;
  top: -6px;
}

.dc-text-edit .dc-text-input:hover {
  border-color: var(--dc-primary-accent-colour);
}

.dc-text-edit .dc-text-input:focus {
  border: 2px solid var(--dc-primary-colour);
  padding: 13px 15px;
}

.dc-text-edit .dc-text-input::placeholder {
  color: var( --dc-accent-text-color);
}

/* Error state */
.dc-text-error-icon {
  display: none;
}

.dc-text-error .dc-text-input,
.dc-text-error .dc-text-input:hover,
.dc-text-error .dc-text-input:focus {
  border-color: var(--dc-primary-error-color);
}

.dc-text-error .dc-text-error-icon {
  display: block;
  left: calc(100% - 32px);
  position: absolute;
  top: 18px;
}

.dc-text-error-icon path {
  fill :var(--dc-primary-error-color)
}

.dc-text-error-msg {
  color: var(--dc-primary-error-color);
  display: none;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  max-width: 272px;
  outline: none;
  padding: 4px 0 0 14px;
  white-space: pre-wrap;
}

.dc-text-error .dc-text-error-msg:not(:empty) {
  display: block;
}

.dc-text-error .dc-text-input::after {
  content: url("data:image/svg+xml,%20%20%20%20%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10%2013.5C10%2012.125%208.875%2011%207.5%2011C6.09375%2011%205%2012.125%205%2013.5C5%2014.9062%206.09375%2016%207.5%2016C8.875%2016%2010%2014.9062%2010%2013.5ZM5.28125%200.8125L5.6875%209.3125C5.71875%209.6875%206.0625%2010%206.4375%2010H8.53125C8.90625%2010%209.25%209.6875%209.28125%209.3125L9.6875%200.8125C9.71875%200.375%209.375%200%208.9375%200H6.03125C5.59375%200%205.25%200.375%205.28125%200.8125Z%22%20fill%3D%22%23CF364E%22%2F%3E%0A%20%20%20%20%3C%2Fsvg%3E");
  height: 16px;
  width: 16px;
}

.dc-text-error .dc-text-help {
  display: none;
}

/* Disabled */
.dc-text-disabled .dc-text-input,
.dc-text-disabled .dc-text-input:hover {
  border-color: var(--dc-ui-disabled-border);
  cursor: not-allowed;
}

.dc-text-disabled .dc-text-label,
.dc-text-disabled .dc-text-input {
  color: var(--dc-greyscale-04);
  cursor: not-allowed;
}

.dc-text-disabled .dc-text-input:hover,
.dc-text-disabled .dc-text-input:focus {
  border-color: var(--dc-ui-disabled-border);
}
